import type { Component } from 'vue';
import Bedtime from '@/icons/requirements/Bedtime.vue';
import LearningPod from '@/icons/requirements/LearningPod.vue';
import Tutoring from '@/icons/requirements/Tutoring.vue';
import CleaningIcon from '@/graphics/icons/CleaningIcon.vue';
import DriveIcon from '@/graphics/icons/DriveIcon.vue';
import ErrandsIcon from '@/graphics/icons/ErrandsIcon.vue';
import HomeworkIcon from '@/graphics/icons/HomeworkIcon.vue';
import LaundryIcon from '@/graphics/icons/LaundryIcon.vue';
import MealsIcon from '@/graphics/icons/MealsIcon.vue';
import NannyShareIcon from '@/graphics/icons/NannyShareIcon.vue';
import PottyIcon from '@/graphics/icons/PottyIcon.vue';
import SickIcon from '@/graphics/icons/SickIcon.vue';
import { Responsibilities } from '@/store/modules/job/types';

export interface ResponsibilityOption {
  value: Responsibilities;
  textLabel: string;
  icon: Component;
  fillsCircle?: boolean;
}

export const responsibilityOptions: ResponsibilityOption[] = [
  { value: Responsibilities.NANNY_SHARE, icon: NannyShareIcon, textLabel: 'Nanny share' },
  { value: Responsibilities.LEARNING_POD, icon: LearningPod, textLabel: 'Learning pod', fillsCircle: true },
  { value: Responsibilities.TUTORING, icon: Tutoring, textLabel: 'Tutoring', fillsCircle: true },
  { value: Responsibilities.DRIVING_THE_KIDS, icon: DriveIcon, textLabel: 'Driving the kids' },
  { value: Responsibilities.HOMEWORK_HELP, icon: HomeworkIcon, textLabel: 'Help with homework' },
  { value: Responsibilities.PREPARE_SNACKS_MEALS, icon: MealsIcon, textLabel: 'Preparing meals/snacks' },
  { value: Responsibilities.SICK_CARE, icon: SickIcon, textLabel: 'Sick care' },
  { value: Responsibilities.SLEEP_TRAINING, icon: Bedtime, textLabel: 'Bedtime', fillsCircle: true },
  { value: Responsibilities.POTTY_TRAINING, icon: PottyIcon, textLabel: 'Toilet training' },
  { value: Responsibilities.LIGHT_HOUSEWORK, icon: CleaningIcon, textLabel: 'Light housekeeping' },
  { value: Responsibilities.DO_LAUNDRY, icon: LaundryIcon, textLabel: 'Light laundry' },
  { value: Responsibilities.RUN_ERRANDS, icon: ErrandsIcon, textLabel: 'Running errands' },
];
